import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import IconVerifySuccess from '@src/assets/icons/ic-verify-success.svg';
import { COLOR } from '@src/styles/color';
import ActionDialog from '@src/new-components/Dialog/ActionDialog';
import CommonButton from '@src/new-components/Button';
import Typography from '@src/new-components/Typography';
import { StyledVerifyVoice } from './index.style';
import Terms from './Terms';
import VoiceRecord from '../VoiceRecord';

const VerifyVoice = ({
  refetchProfessionalSentence,
  professionalSentence,
  handleClose,
  voiceId,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [metadataAudio, setMetadataAudio] = useState(null);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const onSuccessVerifyVoice = useCallback(() => {
    setOpenSuccessDialog(true);
  }, []);

  const handleTermsAccepted = useCallback(() => {
    setTermsAccepted((prev) => !prev);
  }, []);

  const onSetMetadataAudio = useCallback(
    (data) => {
      setMetadataAudio(data);
    },
    [metadataAudio],
  );

  const onResetMetadataAudio = useCallback(() => {
    setMetadataAudio(null);
  }, []);

  useEffect(() => {
    setTermsAccepted(false);
  }, []);

  return (
    <StyledVerifyVoice>
      <Terms
        termsAccepted={termsAccepted}
        onTermsAccepted={handleTermsAccepted}
      />
      <VoiceRecord
        refetchProfessionalSentence={refetchProfessionalSentence}
        termsAccepted={termsAccepted}
        professionalSentence={professionalSentence}
        metadataAudio={metadataAudio}
        onSetMetadataAudio={onSetMetadataAudio}
        onResetMetadataAudio={onResetMetadataAudio}
        voiceId={voiceId}
        onSuccessVerifyVoice={onSuccessVerifyVoice}
      />
      <ActionDialog
        open={openSuccessDialog}
        title={t('voiceVerificationSuccessful')}
        styleTitle={{
          textAlign: 'center',
        }}
        contentComponent={
          <Typography
            style={{ textAlign: 'center' }}
            variant="body-16-regular"
            color={COLOR.descriptionGray}
            dangerouslySetInnerHTML={{
              __html: t('detailsVoiceVerificationSuccessful', {
                email: user?.email,
              }),
            }}
          />
        }
        onClose={() => {
          setOpenSuccessDialog(false);
          handleClose();
        }}
        fullWidth
        image={IconVerifySuccess}
        imageContainerSize="80px"
        width="512px"
        actionComponent={
          <CommonButton
            variant="contained"
            onClick={() => {
              setOpenSuccessDialog(false);
              handleClose();
            }}
            textProps={{
              variantText: 'body-14-semibold',
              color: COLOR.darkBlue,
            }}
            customStyle={{
              padding: '8px 24px',
              borderRadius: '8px',
              height: '40px',
              textTransform: 'none',
            }}
          >
            {t('gotIt')}
          </CommonButton>
        }
      />
    </StyledVerifyVoice>
  );
};

export default VerifyVoice;
